export default "__VITE_ASSET__3OLfZLxQ__"